import { mdlBaseOperationResponse } from "../models/service-models/common/BaseOperationResponse";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlOfferAnswerRequest } from "../models/service-models/offer/OfferAnswerRequest";
import { mdlOfferDetailRequest } from "../models/service-models/offer/OfferDetailRequest";
import { mdlOfferDetailResponse } from "../models/service-models/offer/OfferDetailResponse";
import { mdlOfferHistoryRequest } from "../models/service-models/offer/OfferHistoryRequest";
import { mdlOfferHistoryResponse } from "../models/service-models/offer/OfferHistoryResponse";
import { mdlOfferHotelTypeListForSejourRequest } from "../models/service-models/offer/OfferHotelTypeListForSejourRequest";
import { mdlOfferHotelTypeListForSejourResponse } from "../models/service-models/offer/OfferHotelTypeListForSejourResponse";
import { mdlOfferListRequest } from "../models/service-models/offer/OfferListRequest";
import { mdlOfferListResponse } from "../models/service-models/offer/OfferListResponse";
import { GetResponse } from "../utils/ApiClient";

namespace OfferService {
    export async function List(
        pRequest: mdlOfferListRequest
    ): Promise<mdlServiceResponse<mdlOfferListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlOfferListResponse>>(
            "offer/offerList",
            pRequest
        );
    }
    export async function Detail(
        pRequest: mdlOfferDetailRequest
    ): Promise<mdlServiceResponse<mdlOfferDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlOfferDetailResponse>>(
            "offer/detail",
            pRequest
        );
    }
    export async function HotelTypeListForSejour(
        pRequest: mdlOfferHotelTypeListForSejourRequest
    ): Promise<mdlServiceResponse<mdlOfferHotelTypeListForSejourResponse>> {
        return await GetResponse<mdlServiceResponse<mdlOfferHotelTypeListForSejourResponse>>(
            "offer/hotelTypeListForSejour",
            pRequest
        );
    }
    export async function OfferHistoryList(
        pRequest: mdlOfferHistoryRequest
    ): Promise<mdlServiceResponse<mdlOfferHistoryResponse>> {
        return await GetResponse<mdlServiceResponse<mdlOfferHistoryResponse>>(
            "offer/offerHistoryList",
            pRequest
        );
    }
    export async function Answer(
        pRequest: mdlOfferAnswerRequest
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "offer/answer",
            pRequest
        );
    }
}
export { OfferService };